import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { LoginModalView, useActiveLoginModalContext, useUserAuthenticationContext } from "@/src/contexts";

export default function HashManager(): React.ReactNode {
    const { isAuthenticated } = useUserAuthenticationContext();
    const { setActiveLoginModal } = useActiveLoginModalContext();
    const navigate = useNavigate();

    useEffect(() => {
        const hashChange = (event: CustomEvent<string>) => {
            let prevent = false;
            if (!isAuthenticated) {
                switch (event.detail) {
                    case "rejestracja":
                        setActiveLoginModal(LoginModalView.Registration);
                        prevent = true;
                        break;
                    case "zaloguj":
                        setActiveLoginModal(LoginModalView.Login);
                        prevent = true;
                        break;
                    case "forget-password":
                        setActiveLoginModal(LoginModalView.ForgetPassword);
                        prevent = true;
                        break;
                }
            }

            if (prevent) {
                event.preventDefault();
            }
        };

        window.addEventListener("hashCustomEventChange", hashChange as EventListenerOrEventListenerObject);

        if (window.location.hash.length > 0) {
            const hashChangeEvent = new CustomEvent("hashCustomEventChange", {
                detail: window.location.hash.slice(1),
            });
            if (!window.dispatchEvent(hashChangeEvent)) {
                navigate("#", { replace: true });
            }
        }

        return () => {
            window.removeEventListener(
                "hashCustomEventChange",
                hashChange as EventListenerOrEventListenerObject,
            );
        };
    }, [setActiveLoginModal, isAuthenticated, navigate]);

    return null;
}
